export default __webpack_public_path__ + "static/media/bids8.3027bda8.png";